import React from 'react'
import { Container, Row, Col, Table, Modal, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ThreeDotSpinner } from "../loader";
import { apiService } from '../../service/api.service';
import Pagination from 'react-js-pagination';

const Redemptionhistory = () => {
  const [redeemHistoryList, setRedeemHistoryList] = useState([])
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(0);

  const convertTimeFormatted = (utcTimestamp) => {
    const localTime = new Date(utcTimestamp);

    // Extracting components
    const month = String(localTime.getMonth() + 1).padStart(2, '0');
    const day = String(localTime.getDate()).padStart(2, '0');
    const year = String(localTime.getFullYear());

    return `${day}/${month}/${year}`;
  };


  useEffect(() => {
    fetchRedeemHistory(page)
  }, [])

  const fetchRedeemHistory = async (page = 0) => {
    try {
      const response = await apiService.redeemHistoryList(page + 1);
      setRedeemHistoryList(response.data.data);
      const { currentPage, itemsPerPage, totalItems } = response.data.pagination;
      setPage(currentPage - 1);
      setLimit(itemsPerPage);
      setTotalItems(totalItems);
      console.log("<<<<<<<<<<<<<fetchRedeemHistory>>>>>>>>>>>", response);

    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber - 1);
    fetchRedeemHistory(pageNumber - 1)
  };

  return (
    <>
      {/* {loading ? <ThreeDotSpinner /> : ""}  */}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-3">
              <Col md={12} lg={11}>
                <div className="heading-top-area">
                  <h2 className="align-self-center m-0">Redemption History</h2>
                  {/* <div class="export-csv-btn add-btn-area me-2"><button type="button" class="btn btn-unset" onClick={handleShowAdd}><i class="fa fa-plus" aria-hidden="true"></i> Add</button></div> */}
                </div>
              </Col>

            </Row>
            <Row className="pb-4 justify-content-center">
              <Col md={12} lg={11}>
                <div className="availabilit-section">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Redemption Date</th>
                        <th>Token Name</th>
                        <th>Associated Points Used</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {redeemHistoryList.length > 0 ? redeemHistoryList.map((redeem, index) => (
                        <tr>
                          <td>{page * limit + index + 1}</td>
                          <td>{convertTimeFormatted(redeem?.createdAt)}</td>
                          <td className='tokenName'>
                            {redeem?.redeemed_gift?.name.length > 20  ? `${redeem?.redeemed_gift?.name.slice(0, 20)}...` : redeem?.redeemed_gift?.name}
                            {redeem?.redeemed_gift?.name.length > 20 && <span className='token_tool'>{redeem?.redeemed_gift?.name}</span>}
                          </td>
                          <td>{redeem?.redeemed_gift_points ? redeem?.redeemed_gift_points : "-"}</td>
                          <td className={redeem?.status === 'PENDING' ? 'text-danger pending' : redeem?.status === 'COMPLETE' ? 'text-danger success' : 'text-danger failed'}><span>{redeem?.status}</span></td>
                        </tr>
                      )) :
                        (
                          <tr className="no-dat-found-box">
                            <td colSpan={5}>
                              <img
                                src={
                                  require("../../assets/images/no-data.svg")
                                    .default
                                }
                                alt="da"
                              />
                              <h3 className="text-center text-light">
                                No data found
                              </h3>
                            </td>
                          </tr>
                        )
                      }

                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        {redeemHistoryList?.length > 0 && totalItems > 12 && (
          <Pagination
            activePage={page + 1}
            itemsCountPerPage={limit}
            totalItemsCount={totalItems}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            prevPageText="Prev"
            nextPageText="Next"
          />)}
      </div>
    </>
  )
}

export default Redemptionhistory
